import request from '@/utils/request'

export function apiProductionProcessList (query) {
  return request({
    url: '/bom/bomProductionProcess/list',
    method: 'get',
    params: query
  })
}

export function apiProductionProcessDetail (id) {
  return request({
    url: `/bom/bomProductionProcess/${id}`,
    method: 'get'
  })
}

export function apiProductionProcessAdd (data) {
  return request({
    url: '/bom/bomProductionProcess',
    method: 'post',
    data: data
  })
}

export function apiProductionProcessUpdate (data) {
  return request({
    url: '/bom/bomProductionProcess',
    method: 'put',
    data: data
  })
}

export function apiProductionProcessDelete (ids) {
  return request({
    url: `/bom/bomProductionProcess/${ids}`,
    method: 'delete'
  })
}

export function apiProductionProcessExport (data) {
  return request({
    url: '/bom/bomProductionProcess/export',
    method: 'post',
    data: data
  })
}
